// Utility functions for extracting tracking IDs

export const extractTrackingIds = (): any => {
    const trackingIds: any = {};

    // Extract Google Analytics ID (gtag)
    if (typeof gtag !== 'undefined') {
        // Try to get the GA measurement ID from dataLayer
        if (window.dataLayer) {
            for (const item of window.dataLayer) {
                if (item[0] === 'config' && typeof item[1] === 'string' && item[1].startsWith('G-')) {
                    trackingIds.gtag = item[1];
                    break;
                }
            }
        }
        
        // Fallback: try to extract from gtag script tags
        if (!trackingIds.gtag) {
            const scripts = document.querySelectorAll('script[src*="gtag"]');
            scripts.forEach(script => {
                const src = script.getAttribute('src');
                if (src) {
                    const match = src.match(/id=([^&]+)/);
                    if (match) {
                        trackingIds.gtag = match[1];
                    }
                }
            });
        }
    }

    // Extract Facebook Pixel ID
    if (typeof window.fbq !== 'undefined') {
        // Try to extract from the fbq init call
        try {
            // Facebook Pixel ID is usually initialized with fbq('init', 'PIXEL_ID')
            // We can check the _fbq object or look for it in the script
            const fbScripts = document.querySelectorAll('script');
            for (let i = 0; i < fbScripts.length; i++) {
                const script = fbScripts[i];
                if (script.textContent && script.textContent.includes("fbq('init'")) {
                    const match = script.textContent.match(/fbq\('init',\s*'([^']+)'/);
                    if (match) {
                        trackingIds.fbp = match[1];
                        break;
                    }
                }
            }
        } catch (e) {
            console.warn('Could not extract Facebook Pixel ID:', e);
        }
    }

    // Extract Reddit Pixel ID
    try {
        const redditScripts = document.querySelectorAll('script');
        for (let i = 0; i < redditScripts.length; i++) {
            const script = redditScripts[i];
            if (script.textContent && script.textContent.includes("rdt('init'")) {
                const match = script.textContent.match(/rdt\('init',\s*'([^']+)'/);
                if (match) {
                    trackingIds.rdt = match[1];
                    break;
                }
            }
        }
    } catch (e) {
        console.warn('Could not extract Reddit Pixel ID:', e);
    }

    // Extract any other tracking IDs from cookies or localStorage
    try {
        // Google Analytics Client ID from cookies
        const gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
        if (gaCookie) {
            trackingIds.ga_client_id = gaCookie.split('=')[1];
        }

        // Facebook Click ID from URL parameters (common for ad tracking)
        const urlParams = new URLSearchParams(window.location.search);
        const fbclid = urlParams.get('fbclid');
        if (fbclid) {
            trackingIds.fbclid = fbclid;
        }

        // Google Click ID from URL parameters
        const gclid = urlParams.get('gclid');
        if (gclid) {
            trackingIds.gclid = gclid;
        }
    } catch (e) {
        console.warn('Could not extract additional tracking IDs:', e);
    }

    return trackingIds;
};

// Declare global functions for TypeScript
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
        fbq: (...args: any[]) => void;
        rdt: (...args: any[]) => void;
    }
}
